<template>
  <div :class="classList">
    <ul class="st-table__headers">
      <st-table-item-header
        v-for="header in headers"
        :header="header"
        :key="header.name"
      />
    </ul>
    <ul class="st-table__rows">
      <li
        class="st-table__rows__row"
        v-for="(row, j) in listData"
        :key="j"
        tabindex="0"
        @click="$emit('onClick', row, j)"
      >
        <div class="st-table__columns-wrapper">
          <ul class="st-table__columns">
            <st-table-item
              :value="column.value"
              :is-clickable="column.clickable"
              :icon-name="column.iconName"
              :secondary-value="column.secondaryValue"
              :current-state="column.currentState"
              :item-header="getListItemHeader(i)"
              @onItemClick="$emit('onItemClick', j, row, column.emitValue)"
              v-for="(column, i) in row"
              :key="`${column.value}-${i}-${j}`"
            />
          </ul>
          <div class="st-table__columns__cta">
            <button
              type="button"
              class="st-table__columns__cta__button"
              tabindex="0"
            >
              <span class="st-table__columns__cta__button__title">
                {{ ctaLabel }}
              </span>
              <span class="st-table__columns__cta__button__icon">
                <component
                  :is="icon"
                  :size="'sm'"
                  name="arrow-right"
                  :alt="ctaLabel"
                  useSvg
                  inline
                />
              </span>
            </button>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import StTableItem from "./TableItem.vue";
import StTableItemHeader from "./TableItemHeader.vue";
import StIcon from "../icon/Icon.vue";
import StIconLegacy from "../icon/IconLegacy.vue";
import { version } from "vue";

export default {
  name: "st-table",
  components: {
    StTableItem,
    StTableItemHeader,
    StIcon,
    StIconLegacy,
  },
  props: {
    ctaLabel: {
      type: String,
    },
    listData: {
      type: Array,
    },
    headers: {
      type: Array,
    },
  },
  data() {
    return {};
  },
  computed: {
    classList: function () {
      return ["st-table"];
    },
    icon() {
      return version && parseInt(version) === 3 ? "StIcon" : "StIconLegacy";
    },
  },
  methods: {
    getListItemHeader(index) {
      return this.headers[index];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";
.st-table {
  font-family: $source-sans-pro;
  font-size: rem-calc(16);
  &__headers {
    display: none;
    padding: 0;
    color: $dark-grey;
    font-weight: $semi-bold;
    @include large {
      display: flex;
    }
  }
  &__rows {
    list-style-type: none;
    margin: 0;
    padding: 0;
    &__row {
      &:focus {
        outline-color: $dark-orange;
      }
      &:not(:last-child) {
        margin-bottom: rem-calc(16);
        @include large {
          margin-bottom: rem-calc(8);
        }
      }
    }
  }
  &__columns-wrapper {
    border: solid $solgul-alt;
    background: $solgul-alt;
    border-radius: rem-calc(6);
    overflow: hidden;
    border-width: rem-calc(1) rem-calc(1) rem-calc(1) rem-calc(4);
    @include large {
      border-width: rem-calc(1) rem-calc(1) rem-calc(1) rem-calc(4);
      padding-bottom: 0;
    }
  }
  &__columns {
    display: flex;
    border-radius: 0 0 rem-calc(6) rem-calc(6);
    padding: 0 rem-calc(10);
    background: white;
    cursor: pointer;
    @include large {
      border-width: rem-calc(1) rem-calc(1) rem-calc(1) rem-calc(4);
      border-radius: 0;
      padding: 0;
      &:hover {
        background: $bright-orange;
      }
    }
    &__cta {
      display: flex;
      align-items: center;
      padding: rem-calc(8);
      @include large {
        display: none;
      }
      &__button {
        background: none;
        padding: 0;
        border: none;
        margin-left: auto;
        display: flex;
        font-weight: $semi-bold;
        color: $nästan-svart;
        font-family: inherit;
        &__icon {
          margin-left: rem-calc(2);
        }
      }
    }
  }
  &__columns,
  &__headers {
    margin: 0;
    flex-direction: column;
    list-style-type: none;
    @include large {
      flex-direction: row;
    }
  }
}
</style>
